module.exports = __webpack_public_path__ + "4fb3c62c8c63949d621987df595911ec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-6.png
// module id = 1685
// module chunks = 0